module.exports = __webpack_public_path__ + "img/monthlyIcon.7d35b024.svg";